import { Grid } from "designSystem/index";
import MultiSelect from "designSystem/components/select/MultiSelect";
import React from "react";
import { items } from "designSystemLegacy/data";

export default () => {
	// callback for value change and drop-down close
	const onChangeValue = (event, newValues, reason) => {
		alert("This would happen either clear/delete the value or close the drop-down, but not check/uncheck the values in the drop-down");
	};

	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<MultiSelect
					onChange={onChangeValue}
					options={items}
					value={[items[0]]}
				/>
			</Grid>
		</Grid>
	);
};